import { useDialogContext } from "@ariakit/react";
import { LetterheadSubmitError, useForm } from "@indietabletop/appkit";
import { toast } from "react-hot-toast";
import { database } from "../../database.ts";
import type { Gang } from "../../engine/Gang.ts";
import { FormDialog, FormDialogActions } from "../FormDialog/FormDialog.tsx";
import { FormDialogSubmitButton } from "../forms/DialogSubmitButton.tsx";
import { FormOption, FormOptions } from "../forms/FormTextField.tsx";
import { PremiumContentNote } from "../PremiumContentNote/PremiumContentNote.tsx";
import { RichContent } from "./PremiumContent.tsx";

export function ChooseFactionDialog(props: { gang: Gang }) {
  const { gang } = props;
  const dialog = useDialogContext();

  const { form, submitName } = useForm({
    defaultValues: {
      factionId: gang.data.faction?.id ?? "",
    },

    async onSubmit({ values }) {
      return await database.gangs.setFaction(
        gang,
        values.factionId ? { id: values.factionId } : null
      );
    },

    onSuccess() {
      dialog?.hide();
      toast("Saved");
    },
  });

  return (
    <FormDialog
      overline="City of Gnork"
      heading="Faction Affiliation Disclaimer"
      form={form}
    >
      <PremiumContentNote />

      <FormOptions label="Factions">
        {gang.ruleset.factions.toArray().map((g) => {
          const specialRule = g.rules.at(0);

          return (
            <FormOption
              type="checkbox"
              key={g.id}
              name={form.names.factionId}
              value={g.id}
              label={g.name}
              description={
                specialRule && (
                  <>
                    <strong>{specialRule.name}: </strong>
                    <RichContent>{specialRule.description}</RichContent>
                  </>
                )
              }
            />
          );
        })}
      </FormOptions>

      <FormDialogActions>
        <LetterheadSubmitError name={submitName} />

        <FormDialogSubmitButton>Save</FormDialogSubmitButton>
      </FormDialogActions>
    </FormDialog>
  );
}
